import {
  type SpaceDispatchTraceResponse,
  spaceDispatchTraceResponseSchema,
  type WakeLoopRequestContext,
} from "@wakeloop/schemas";
import { toSpaceDispatchTraceUrl } from "../protocol/urls";
import { fetchSpaceRequestWithTimeout } from "../space/fetch-with-timeout";
import { buildWakeLoopRequestContextHeadersWithAuth } from "./request-headers";

export async function fetchSpaceDispatchTrace(input: {
  requestContext: WakeLoopRequestContext;
  baseUrl: string;
  space: string;
  dispatchId: string;
  password?: string;
}): Promise<SpaceDispatchTraceResponse> {
  const endpoint = toSpaceDispatchTraceUrl(
    input.baseUrl,
    input.space,
    input.dispatchId
  );
  const response = await fetchSpaceRequestWithTimeout({
    url: endpoint,
    operation: "space.dispatch_trace",
    init: {
      headers: await buildWakeLoopRequestContextHeadersWithAuth({
        requestUrl: endpoint,
        requestContext: input.requestContext,
        spacePassword: input.password,
      }),
    },
  });
  const raw = await response.text();
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${raw}`);
  }

  const parsed = spaceDispatchTraceResponseSchema.safeParse(parseJson(raw));
  if (!parsed.success) {
    throw new Error("invalid space dispatch trace response");
  }
  return parsed.data;
}

function parseJson(raw: string): unknown {
  if (!raw.trim()) {
    return null;
  }

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
